module.exports = __webpack_public_path__ + "static/example-img-43d80da308c7a7a90017ee03ad2a8e0e.png";